import { AfterViewInit, Directive, ElementRef, Input, NgZone, Output, EventEmitter, Optional, Inject, PLATFORM_ID } from '@angular/core';
import { importLibrary } from '@googlemaps/js-api-loader';
import { RadGpAutocompleteOptions } from './rad-gp-autocomplete-options';
import { RadGpAutocompleteService } from './rad-gp-autocomplete.service';
import { isPlatformBrowser } from '@angular/common';

declare let google: any;

@Directive({
	selector: '[radGpAutocomplete]',
	exportAs: 'radGpAutocomplete'	
})
export class RadGpAutocompleteDirective implements AfterViewInit {
	@Input() options: RadGpAutocompleteOptions;
	@Output() onAddressChange: EventEmitter<google.maps.places.PlaceResult> = new EventEmitter();

	public place?: google.maps.places.PlaceResult;
	private eventListener?: any;
	private autocomplete!: google.maps.places.Autocomplete;
	
	constructor(
		public el: ElementRef,
		private ngZone: NgZone,
		private radGpAutocompleteService: RadGpAutocompleteService,
		@Inject(PLATFORM_ID) private platformId: Object,
	) { }

	async ngAfterViewInit(): Promise<void> {
		if (!isPlatformBrowser(this.platformId)) return;

		this.options ??= this.radGpAutocompleteService.getOptions();

		if (!this.googleLibExists()) {
			await importLibrary("places")
		}

		this.initialize();
	}

	private googleLibExists(): boolean {
		return typeof google !== 'undefined' && google.maps?.places;
	}

	private initialize(): void {
		const inputEl = this.el.nativeElement;

		this.autocomplete = new google.maps.places.Autocomplete(inputEl, this.options);

		this.eventListener = this.autocomplete.addListener('place_changed', () => {
			this.handleChangeEvent()
		});

		this.preventEnterSubmit();
		this.fixIosTouchEvents();
	}

	private handleChangeEvent(): void {
		this.ngZone.run(() => {
			this.place = this.autocomplete.getPlace();
			if (this.place) this.onAddressChange.emit(this.place);
		})
	}

	private preventEnterSubmit(): void {
		this.el.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
			if (event.key.toLowerCase() === 'enter') {
				event.preventDefault();
				event.stopPropagation();
			}
		});
	}

	private fixIosTouchEvents(): void {
		if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      		setTimeout(() => {
        		const containers = document.getElementsByClassName('pac-container');
        		for (const container of Array.from(containers)) {
          		container.addEventListener('touchend', e => e.stopImmediatePropagation());
        		}
      		}, 500);
		}
	}

	public reset(): void {
		this.autocomplete.setComponentRestrictions(this.options.componentRestrictions);
		this.autocomplete.setTypes(this.options.types);
	}
}

